document.addEventListener('DOMContentLoaded', () => {
    const faqToggles = document.querySelectorAll('.faq-toggle');
    faqToggles.forEach((faqToggle) => {
        faqToggle.addEventListener('click', (e) => {
            let parent = e.currentTarget.closest('.faq');
            let content = parent.querySelector('.faq-answer');
            if (parent.classList.contains('active')) {
                parent.classList.remove('active');
                content.style.height = 0;
            } else {
                document.querySelectorAll('.faq.active').forEach((x) => {
                    x.classList.remove('active');
                    x.querySelector('.faq-answer').style.height = 0;
                });
                parent.classList.add('active');
                content.style.height = content.scrollHeight + 'px';
            }
        });
    });

    window.addEventListener('resize', resizeHandler);
    function resizeHandler() {
        document.querySelectorAll('.faq.active').forEach((x) => {
            let answer = x.querySelector('.faq-answer');
            answer.style.height = x.querySelector('.faq-answer-rt').scrollHeight + 'px';
        });
    }
});